const CONTAINER_WIDTH = 1280;

export const getStyles = () => ({
  container: {
    minHeight: "100vh",
    overflow: "hidden",
  },
  mainContent: {
    "& > *": {
      paddingInline: "16px",
      "@media (min-width: 960px)": {
        paddingInline: 0,
        display: "grid",

        gridTemplateColumns: `minmax(16px, 1fr) minmax(0, ${
          CONTAINER_WIDTH / 2
        }px) minmax(0, ${CONTAINER_WIDTH / 2}px) minmax(16px, 1fr)`,
      },
    },
  },

  cookieConsentContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    justifyContent: "space-between",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    padding: "40px",
    backgroundColor: "#ffffff",
    borderRadius: 0,
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",

    "& .MuiLink-root": {
      cursor: "pointer",
    },

    "@media (min-width: 960px)": {
      padding: "64px 80px",
    },
  },
});
